import UserInterface from "./UserInterface";
import { useContext } from "react";
import { SocketContext } from "../../../../Context";
import DaillingInterface from "./DaillingInterface";
const Calling = () => {
  const { callAccepted } = useContext(SocketContext);
  return (
    <>
      <UserInterface style={!callAccepted ? "d-none" : ""} />
      <DaillingInterface style={callAccepted ? "d-none" : ""} />
    </>
  );
};

export default Calling;
  